import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, tap } from 'rxjs';

import { BaseService } from './base.service';
import { environment } from '../../environments/environment';
import { AdvanceSearchCriteria } from '../models/AdvanceSearchCriteria';
import { Conditioner } from '../models/features/conditioner/Conditioner';
import { ConditionerMasterCompanyYear } from '../models/features/conditioner/ConditionerMasterCompanyYear';

import { Product } from '../models/features/product/Product';
import { PagedResponse } from '../models/PagedResponse';
import { ConditionerProduct } from '../models/features/conditioner/ConditionerProduct';

@Injectable({
  providedIn: 'root',
})
export class ConditionerService extends BaseService<ConditionerMasterCompanyYear> {
  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}/conditioner/v1`);
  }

  public searchConditioners(
    advanceSearchCriteria: AdvanceSearchCriteria,
    companyYear: number,
  ): Observable<HttpResponse<PagedResponse<ConditionerMasterCompanyYear>>> {
    this.loadingSubject.next(true);
    const params = new HttpParams().set('companyYear', companyYear);
    return this.httpClient
      .post<
        PagedResponse<any>
      >(`${this.baseApiUrl}/advancedSearch`, advanceSearchCriteria, { params, observe: 'response' })
      .pipe(
        tap((response) => {
          this.loadingSubject.next(false);
        }),
        catchError(() => {
          this.loadingSubject.next(false);
          return EMPTY;
        }),
      );
  }

  public lookupByCodeAndYear(
    code: string,
    year: number,
    count: number = 5,
  ): Observable<HttpResponse<Array<Conditioner>>> {
    const params = new HttpParams()
      .set('code', code)
      .set('year', year)
      .set('count', count);
    return this.httpClient.get<Conditioner[]>(
      `${this.baseApiUrl}/lookupByCodeAndYear`,
      { params, observe: 'response' },
    );
  }

  public searchConditionerProductss(
    advanceSearchCriteria: AdvanceSearchCriteria,
    companyYear: number,
  ): Observable<HttpResponse<PagedResponse<Product>>> {
    this.loadingSubject.next(true);
    const params = new HttpParams().set('companyYear', companyYear);
    return this.httpClient
      .post<
        PagedResponse<any>
      >(`${this.baseApiUrl}/conditionerProduct/advancedSearch`, advanceSearchCriteria, { params, observe: 'response' })
      .pipe(
        tap((response) => {
          this.loadingSubject.next(false);
        }),
        catchError(() => {
          this.loadingSubject.next(false);
          return EMPTY;
        }),
      );
  }

  public updateProductsQtyandAvailable(
    requestBody: ConditionerProduct[],
  ): Observable<HttpResponse<any>> {
    this.loadingSubject.next(true);
    return this.httpClient
      .post(`${this.baseApiUrl}/conditionerProduct/save`, requestBody, {
        observe: 'response',
      })
      .pipe(
        tap(() => {
          this.loadingSubject.next(false);
        }),
        catchError(() => {
          this.loadingSubject.next(false);
          return EMPTY;
        }),
      );
  }

  public markAllProductsAsSoldout(
    varietyCode: string,
    crop : string,
    year: number,
  ): Observable<HttpResponse<any>> {
    this.loadingSubject.next(true);
    const params = new HttpParams()
      .set('varietyCode', varietyCode)
      .set('crop', crop ? crop:'00')
      .set('year', year);
    return this.httpClient
      .post(
        `${this.baseApiUrl}/conditionerProduct/markAsSoldOut`,
        {},
        {
          params,
          observe: 'response',
        },
      )
      .pipe(
        tap(() => {
          this.loadingSubject.next(false);
        }),
        catchError(() => {
          this.loadingSubject.next(false);
          return EMPTY;
        }),
      );
  }

  public lookupConditionerByProductAndYear(
      productCode: string,
      year: number
    ): Observable<HttpResponse<any[]>> {
      const params = new HttpParams()
        .set('productCode', productCode)
        .set('year', year)
      return this.httpClient.get<any[]>(
        `${environment.apiUrl}/conditioner/v1/lookupConditionerByProductAndYear`,
        { params, observe: 'response' },
      );
    }

}
